import * as Models from "../.";
export interface IGetUsersResponse {
  users: Array<Models.ManageUsers.UserView.IUserView>;
  skip: number;
  take: number;
  count: number;
}

export class GetUsersResponse implements IGetUsersResponse {
  users: Array<Models.ManageUsers.UserView.IUserView>;
  skip: number;
  take: number;
  count: number;
}
